<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <rx-rich-dropdown *ngIf="selectedCurrencyObj$ | async as selectedCurrencyObj">
    <span host class="nav-link" [innerHtml]="selectedCurrencyObj.code + ' ' + selectedCurrencyObj.symbol"></span>
    <span menuLabel>{{ t('instruction') }}</span>
    <button
      class="dropdown-item"
      *ngFor="let currency of currencies$ | async"
      [ngClass]="{ active: currency.code === selectedCurrencyObj.code }"
      (click)="optionSelectedClick(currency.code)"
    >
      {{ currency.code }} - <span [innerHTML]="currency.symbol"></span>
    </button>
  </rx-rich-dropdown>
</ng-container>
